import React, { useEffect } from 'react';
import { useProjects } from '../context/ProjectContext';
import { CheckIcon, CloseIcon, FolderIcon } from './icons';

interface Props {
  title: string;
  currentProjectId: string | null;
  onChoose: (projectId: string | null) => void;
  onClose: () => void;
}

const MoveToProjectDialog: React.FC<Props> = ({ title, currentProjectId, onChoose, onClose }) => {
  const { projects } = useProjects();

  useEffect(() => {
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKeyDown);

    return () => window.removeEventListener('keydown', onKeyDown);
  }, [onClose]);

  const options: { id: string | null; name: string }[] = [
    ...projects.map((p) => ({ id: p.id, name: p.name })),
    { id: null, name: 'No project' },
  ];

  return (
    <div className="cv-modal-backdrop" onClick={onClose}>
      <div
        className="cv-modal cv-modal--confirm"
        role="dialog"
        aria-modal="true"
        aria-labelledby="cv-move-title"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="cv-modal__header">
          <h2 id="cv-move-title" className="cv-modal__title">Move to project</h2>
          <button type="button" className="cv-icon-btn" onClick={onClose} aria-label="Close"><CloseIcon /></button>
        </div>
        <p className="cv-move__chat">{title}</p>
        {projects.length === 0 && <p className="cv-move__empty">No projects yet. Create one under Projects in the sidebar.</p>}
        <ul className="cv-move__list">
          {options.map((option) => {
            const isCurrent = option.id === currentProjectId;

            return (
              <li key={option.id ?? 'none'}>
                <button
                  type="button"
                  className={`cv-move__option${isCurrent ? ' is-current' : ''}`}
                  onClick={() => (isCurrent ? onClose() : onChoose(option.id))}
                  aria-current={isCurrent ? 'true' : undefined}
                >
                  {option.id ? <FolderIcon size={16} /> : <CloseIcon size={16} />}
                  <span>{option.name}</span>
                  {isCurrent && <CheckIcon size={16} />}
                </button>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default MoveToProjectDialog;
